export const PRODUCTION_ASSETS = 'https://simulador360vr.revigres.pt/assets'
export const DEVELOP_ASSETS = 'https://aw-proj19-assets.s3.eu-west-2.amazonaws.com'

export const ASSETS_FOLDER = process.env.REACT_APP_ENVIRONMENT === 'production' ? PRODUCTION_ASSETS: PRODUCTION_ASSETS;
